import React, { useEffect, useState } from 'react';
import ParentCardNoCol from '../../common/ParentCardNoCol';
import EnvironmentSelect from '../../../common/formElements/EnvironmentSelect';
import CustomFunctionLogsTable from './CustomFunctionLogsTable';

function CustomFunctionLogs({ customFunctionId, collections, projectId, actions, version }) {
  const [name, setName] = useState('customFunction');
  const [nameLoading, setNameLoading] = useState(true);

  const loadFunctionName = async () => {
    if (name !== 'customFunction') return;

    setNameLoading(true);
    try {
      const nameData = await actions.loadCustomFunctionDetail({
        projectId,
        customFunctionId,
        version,
      });
      const data = nameData.data;
      const functionName = data.name || 'customFunction';
      setName(functionName);
    } catch (error) {
      console.error('Error loading function name:', error);
    } finally {
      setNameLoading(false);
    }
  };

  useEffect(() => {
    if (customFunctionId) {
      loadFunctionName();
    }
  }, [customFunctionId]);

  return (
    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
      <ParentCardNoCol
        title={nameLoading ? 'Loading...' : `${name} logs`}
        icon="customFunction"
        bgColor="drapcode-violet"
        CtaComponent={
          <button
            className="btn btn-md btn-default"
            onClick={() => document.dispatchEvent(new CustomEvent('refreshLogs'))}
          >
            <i className="wb webconnect-refresh" />
          </button>
        }
      >
        <div className="row justify-content-end">
          <div className="col-sm-12 col-md-3 mb-3">
            <EnvironmentSelect
              projectId={projectId}
              version={version}
              refreshMethod={() => document.dispatchEvent(new CustomEvent('refreshLogs'))}
              environment={collections.projectDetails}
              actions={actions}
            />
          </div>
        </div>

        <CustomFunctionLogsTable
          projectId={projectId}
          customFunctionId={customFunctionId}
          actions={actions}
        />
      </ParentCardNoCol>
    </div>
  );
}

export default CustomFunctionLogs;
